export default "__VITE_ASSET__C4q2fvXZ__"